import React from 'react'
import { Route, IndexRoute } from 'react-router'

import * as UI from './components'
import * as Screens from './screens'

export default (
  <Route path="/">
    <Route component={Screens.Storefront}>
      <Route component={UI.HeaderLayout}>
        <Route component={UI.SidebarLayout}>
          <IndexRoute
            components={{
              main: Screens.Allocation,
              sidebar: Screens.AllocationSidebar,
            }}
          />
          <Route
            path="closed"
            components={{
              main: Screens.Closed,
              sidebar: Screens.AllocationSidebar,
            }}
          />
        </Route>

        <Route path="purchase/:purchaseId" components={Screens.Purchase}>
          <Route component={UI.SidebarLayout}>
            <IndexRoute
              components={{
                main: Screens.Invoice,
                sidebar: Screens.InvoiceSidebar,
              }}
            />
            <Route
              path="receipt"
              components={{
                main: Screens.Receipt,
                sidebar: Screens.ReceiptSidebar,
              }}
            />
            <Route
              path="expired"
              components={{
                main: Screens.ExpiredPurchase,
                sidebar: Screens.ReceiptSidebar,
              }}
            />
          </Route>
        </Route>

        <Route component={UI.CenteredLayout}>
          <Route path="countdown" component={Screens.Countdown} />
          <Route path="settings" component={Screens.Settings} />
          <Route
            path="identity_validation"
            component={Screens.IdentityValidation}
          />
        </Route>
      </Route>

      <Route component={UI.CenteredLayout}>
        <Route path="signup/:token" component={Screens.TokenSignUp} />
        <Route path="signup" component={Screens.SignUp} />
        <Route path="login" component={Screens.Login} />
      </Route>
    </Route>

    <Route path="logout" component={Screens.Logout} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js